import { IntlProvider } from "react-intl";
import { ComponentPropsWithoutRef } from "react";
import { FullLocale, locales } from "../utils/locale.ts";
import { Helmet } from "react-helmet-async";
import { ToastProvider } from "../../routes/root/core-ui/toast/toastContext.tsx";
import ToastContainer from "../../routes/root/core-ui/toast/ToastContainer.tsx";

type ProviderProps = ComponentPropsWithoutRef<typeof IntlProvider>;

const defaultLang: FullLocale = "en-US";

export default function DeweyIntlProvider({
  children,
  ...props
}: Omit<ProviderProps, "locale"> & {
  locale?: FullLocale;
}) {
  const lang = props.locale ?? defaultLang;
  const dir = locales[lang]?.dir;

  return (
    <>
      <Helmet htmlAttributes={{ lang, dir }} />
      <IntlProvider defaultLocale={defaultLang} locale={defaultLang} {...props}>
        <ToastProvider>
          {children}
          <ToastContainer />
        </ToastProvider>
      </IntlProvider>
    </>
  );
}
